import React, { FunctionComponent } from 'react';
import { Props } from './UWTableHeader.types';
import styles from './UWTableHeader.module.scss';

const UWTableHeader: FunctionComponent<Props> = ({ header }) => {
  return (
    <tr className={styles.header}>
      {header.map((item, i) => (
        <td key={`header-${i}`}>{item}</td>
      ))}
    </tr>
  );
};

export default UWTableHeader;
